import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hackaton-smart-contract',
  templateUrl: './hackaton-smart-contract.component.html',
  styleUrls: ['./hackaton-smart-contract.component.css']
})

export class HackatonSmartContractComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
